/* global axios */
import ApiClient from './ApiClient';

class MacrosAPI extends ApiClient {
  constructor() {
    super('macros', { accountScoped: true });
  }

  executeMacro({ macroId, conversationIds, variables = {} }) {
    return axios.post(`${this.url}/${macroId}/execute`, {
      conversation_ids: conversationIds,
      variables,
    });
  }

  getVariables(macroId) {
    return axios.get(`${this.url}/${macroId}/variables`);
  }
}

export default new MacrosAPI();
